import React from 'react';
import {Button, FormControl, FormGroup, InputGroup} from 'react-bootstrap';
import Select from 'react-select';
import FontAwesome from 'react-fontawesome';
// import SWTCarEditModal from '../../../view/workdoc/SWTCarEditModal';
import {connect} from 'react-redux';
import {setOption} from './FormAction';
import SWTNewCustomerModal from '../../../view/workdoc/SWTNewCustomerModal';

class SelectCustomer extends React.Component {

  constructor(...args) {
    super(...args);
    this.initial();
    this.state = {
      modal: false,
    };
  }

  initial() {
    
  }

  onFormChange(e) {
    let {uiSchema} = this.props
    if (uiSchema['ui:multi']&&!uiSchema['ui:select']) {
      this.props.onChange(e)
    } else {  
      this.props.onChange(e.target.value)
    }  
  }

  selectedCustomer(customer) {
    let {uiSchema,formData} = this.props
    if (uiSchema['ui:multi']&&!uiSchema['ui:select']) {
      let evalue = {label:customer.name,value:customer.customer_id}
      let data = formData
      if (data===''||data.length===0)
        data = [evalue]
      else  
        data.push(evalue)
      this.props.onChange(data);
    } else {
      this.props.onChange(Object.assign({isSelect:true,identity_no: '', name: customer.name, tel: customer.tel, address: customer.address, postalcode: '', other_tel: '', title: '', driver_license_no: '', province: ''},customer))
    }  
  }

  openModal = () => {
    this.setState({modal: true});
  };

  closeModal = () => {
    this.setState({modal: false});
  };

  render() {
    const {
      // store,
      formData,
      uiSchema,
      disabled, readonly,
    } = this.props;
    
    return (
        <div>
          {uiSchema['ui:input']
          ?
          <FormGroup>
              <InputGroup>
                <FormControl value={formData} onChange={this.onFormChange.bind(this)}/>
                <InputGroup.Addon 
                  disabled={disabled}
                  readOnly={readonly}
                  className='btn' 
                  onClick={this.openModal}
                >
                  <FontAwesome name='plus'/>
                </InputGroup.Addon>
              </InputGroup>            
            </FormGroup>
          :uiSchema['ui:multi']&&!uiSchema['ui:select']
          ?
          <FormGroup>
            <InputGroup>
              <Select
                multi={uiSchema['ui:multi']}
                removeSelected={true}
                readOnly={true}
                disabled={formData===''||formData.length===0?true:false}
                searchable={false}
                placeholder={'โปรดระบุ'}
                clearable={false}
                value={formData}
                options={[]}
                onChange={this.onFormChange.bind(this)}
              />
              <InputGroup.Addon 
                disabled={disabled}
                readOnly={readonly}
                className='btn' 
                onClick={this.openModal}
              >
                <FontAwesome name='plus'/>
              </InputGroup.Addon>
            </InputGroup>            
          </FormGroup>  
          :
          <Button
              disabled={disabled}
              readOnly={readonly}
              className="btn"
              onClick={this.openModal}
          >
            <FontAwesome name="users" /> เลือก...
          </Button>
          }
          <SWTNewCustomerModal
              show={this.state.modal}
              mode={uiSchema.type}
              onHide={this.closeModal}
              onSelect={this.selectedCustomer.bind(this)}
          />
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  store: state,
});

const mapDispatchToProps = ({
  setOption,
});

const SelectCarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectCustomer);

export default SelectCarContainer;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/SelectCustomer.js